import React from 'react';
import { useState } from 'react';
import { ExpandMore } from '@/components/expand-more/expand-more';
import { DialogHeader, DialogTitle } from '@/components/ui/dialog';

const ValidateDocumentRequirements = () => {
	const [expandedDF, setExpandedDF] = useState(true);

	return (
		<>
			<DialogHeader>
				<DialogTitle>Validación de documentos</DialogTitle>
			</DialogHeader>
			<ExpandMore
				title="Documento firmado"
				body={
					<>
						<p>
							El servicio de validación de documentos permite
							determinar si el documento fue firmado con nuestros
							sistemas y provee información importante como número
							de serie, fecha de firma, fecha de expiración, entre
							otros.
						</p>
						<p>
							Este servicio sólo acepta documentos <b>.pdf</b>
						</p>
					</>
				}
				isCollapsed={!expandedDF}
				toggleExpand={() => setExpandedDF(!expandedDF)}
			/>
		</>
	);
};

export default ValidateDocumentRequirements;
